export default __webpack_public_path__ + "static/media/more-horizontal.7c3e7d29.svg";